import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IWebviewViewService = ( createDecorator('webviewViewService'));
export { IWebviewViewService };
